export default __webpack_public_path__ + "static/media/caret-left.8b2b1e36.svg";